"use client";

import ShinyText from "@/components/shiny-text";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useLocalStorageReady } from "@/hooks/useLocalStorageReady";

interface LocalStorageProviderProps {
  children: React.ReactNode;
}

export const LocalStorageProvider = ({
  children,
}: LocalStorageProviderProps) => {
  const isReady = useLocalStorageReady();

  if (!isReady) {
    return (
      <div className="relative flex min-h-screen flex-col">
        <div className="flex overflow-hidden">
          <main className="relative z-10 flex h-[calc(100vh)] flex-1 items-center justify-center overflow-hidden bg-background/80">
            <Card className="w-full max-w-md overflow-hidden rounded-none border-0 bg-background shadow-2xl backdrop-blur-sm sm:w-[448px] sm:rounded-xl">
              <CardHeader>
                <CardTitle className="text-2xl font-semibold tracking-tight">
                  Loading...
                </CardTitle>
                {/* <CardDescription>
                  We are preparing your experience
                </CardDescription> */}
              </CardHeader>
              <CardContent className="relative">
                <ShinyText text="We are preparing your experience, please wait" />
              </CardContent>
            </Card>
          </main>
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `url('/image.webp') no-repeat center center`,
            backgroundSize: "cover",
          }}
        />
      </div>
    );
  }

  return <>{children}</>;
};
